<template>
  <div class="qyclsb">
    <div class="u-text-center">
      <car-form
        @submit="submit"
        :showformitem="['plateNo', 'plateColor', 'vehicleType', 'checkStatus']"
      >
      <template>
         <el-button type="success" size="small" @click="add">添加</el-button>
      </template>
      </car-form>
    </div>
    <div class="u-h-100">
      <hy-data-table
        v-model="loading"
        height="94%"
        ref="dataTable"
        @find-page="findPage"
        @detail-handle="detailHandle"
        @del="del"
        is-all-handle
        :data="dataTable.list"
        :columns="dataTable.columns"
        :extend-buttons="dataTable.buttons"
        :show-batch-delete="false"
        :show-operation="true"
        size="medium"
        :paging="dataTable.paging"
        :extend-but-widht="130"
      ></hy-data-table>
    </div>
  </div>
</template>

<script>
import carForm from '@/components/form/carForm.vue';
import hyDataTable from '@/components/HyDataTable.vue';
import { mapState } from 'vuex';

export default {
  components: {
    carForm,
    hyDataTable
  },
  data() {
    return {
      saveAddTemplate: {},
      sortName: [
        '车牌号码',
        '车牌颜色',
        '车牌种类',
        '车辆品牌',
        // '子品牌',
        '车辆年代款',
        '车辆类型',
        '申请所属公司',
        '车型类别',
        '部门编号',
        '申报来源',
        '车脸图片',
        '有效期范围',
        '通行时间范围',
        '审批状态',
        '创建时间',
        '审批意见',
        '审批时间',
        '备注',
        '审批人'
      ],
      apiUrl: {
        imgUploadApi: this.$apis.POST_hyCarUploadImg,
        delApi: 'GET_hyCarDelete',
        addApi: 'POST_hyCarAdd',
        detailApi: 'GET_hyCarFind',
        updateApi: 'POST_hyCarUpdate',
        approvalApi: 'POST_hyCarVerifyEnterprise',
        indexApi: 'POST_hyCarIndex'
      },
      form: {},
      loading: false, // 是否加载的标识
      pageRow: 10,
      pageIndex: 1,
      dataTable: {
        list: {
          // "status": "S",
          // "msg": "查询成功",
          // "count": 1,
          // "pageIndex": 1,
          // "pageRow": 10,
          // "data": [
          //     {
          //         "num": "123456",
          //         "carNum": "粤S12345",
          //         "time": "2022-02-23 18:28:36",
          //         "vehicleType": "小型蓝牌",
          //         "color": "蓝",
          //         // "picPath": "http://10.0.6.170:8089/{6E015000-A034-45E9-A476-C90751C29585}.jpg",
          //         "pinType": "奥迪A7",
          //         "typeB": "小型客车",
          //         "device": "治安卡口",
          //         "street": "东莞市XX街道XX大道"
          //     }
          // ]
        },
        columns: [
          { prop: 'plateNo', label: '车牌号码', minWidth: 100 },
          { prop: 'plateClass', label: '车牌种类', minWidth: 100 },
          { prop: 'plateColor', label: '车牌颜色', minWidth: 80 },
          { prop: 'vehicleBrand', label: '车辆品牌', minWidth: 50 },
          // { prop: 'vehicleModel', label: '子品牌', minWidth: 50 },
          { prop: 'vehicleClass', label: '车辆类型', minWidth: 80 },
          { prop: 'carCompany', label: '申请所属公司', minWidth: 130 },
          { prop: 'passTime', label: '通行时间范围', minWidth: 100 },
          { prop: 'validityPeriodTime', label: '有效期限', minWidth: 100 },
          { prop: 'vehicleType', label: '车型类别', minWidth: 70 },
          { prop: 'checkStatus', label: '审批状态', minWidth: 70 }
        ],
        buttons: [
          {
            label: '详情',
            click: 'detail-handle',
            perms: 100103,
            // icon: 'fa fa-picture-o',
            type: 'primary'
          },
          {
            label: '删除',
            click: 'del',
            perms: 100102,
            // icon: 'fa fa-picture-o',
            type: 'error'
          }
        ],
        paging: {
          pageIndex: 1 // 表格分页信息
        }
      }
    };
  },
  computed: {
    ...mapState({
      boxDetailRerefsh: (state) => state.detail.boxDetailRerefsh
    })
  },
  methods: {
    submit(form) {
      this.form = form;
      // this.form = {
      //   checkStatus: form.checkStatus,
      //   coEin: form.coEin,
      //   coName: form.coName
      // };
      this.pageIndex = 1;
      this.getData();
    },
    findPage(res1) {
      console.log('findPage');
      this.pageIndex = res1.pageRequest.pageIndex;
      this.getData();
    },
    add() {
      let data = this.saveAddTemplate;
      data.carFrom = 1;
      this.$store.commit('boxDetail', {
        data: data,
        title: '新增',
        api: this.apiUrl.addApi,
        uploadImgApi: this.apiUrl.imgUploadApi,
        sort: this.sortName
      });
    },
    detailHandle(res) {
      const data = res.row;
      const id = data.id || data.personNo;
      this.$http[this.apiUrl.detailApi]({ paramsID: id }).then((response) => {
        if (response.data) {
          response.data.carFrom = 1;
          this.$store.commit('boxDetail', {
            data: response.data,
            title: '详情',
            api: this.apiUrl.updateApi,
            uploadImgApi: this.apiUrl.imgUploadApi,
            sort: this.sortName
          });
        }
      });
    },
    del(res) {
      const id = res.row.id || res.row.personNo;
      this.$http[this.apiUrl.delApi]({ paramsID: id }).then((response) => {
        if ((response.code = '00000')) {
          this.$message.success('删除成功');
          if (this.dataTable.list.data.length === 1)
            this.pageIndex = this.pageIndex - 1;
          this.getData();
        } else {
          this.$message.error('删除失败:' + response.msg);
        }
      });
    },
    getData() {
      this.form.pageIndex = this.pageIndex;
      this.form.pageRow = this.pageRow;
      this.form.carFrom = 1;
      let arr = [];
      this.$http[this.apiUrl.indexApi](this.form)
        .then((response) => {
          if (response.data && response.data.length > 0) {
            for (var i = 0; i < response.data.length; i++) {
              let result = this.$myPlug.sortName2cn(response.data[i]);
              result.validityPeriodTime = result.validityPeriodStart
                ? result.validityPeriodStart + '至' + result.validityPeriodEnd
                : '';

              arr.push(result);
            }
          }
          this.dataTable.list = {
            pageRow: this.pageRow,
            count: response.total,
            pageIndex: 1,
            data: []
          };
          this.$set(this.dataTable.list, 'data', arr);
          this.saveAddTemplate = JSON.parse(
            JSON.stringify(this.dataTable.list.data[0])
          );
        })
        .catch((error) => {
          console.log(error);
        });
    }
  },
  created() {
    this.getData();
  },
  watch: {
    boxDetailRerefsh(nval) {
      if (nval) this.getData();
    }
  }
};
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/views/sbgl/qyclsb.vue